import { Box, Flex, Grid, Heading, Image, Link, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

interface OnboardingLinkType {
	text: string;
	href: string;
}

export const OnboardingItem = ({
	step,
	content,
	image,
	header,
	links,
}: {
	step: number;
	content: React.ReactNode;
	image: string;
	header: string;
	links?: OnboardingLinkType[];
}) => {
	const { t } = useTranslation();

	return (
		<Grid
			gridTemplateColumns={{ base: '1fr', lg: '1fr 1fr' }}
			padding={{ base: '22px', lg: '88px' }}
			border="1px solid #2F2F2F"
			borderRadius="4px"
			bg="#171717"
		>
			<Box>
				<Box
					color="#FF3F3F"
					fontSize="14px"
					lineHeight="120%"
					fontWeight="600"
					textTransform="uppercase"
				>
					{t('onboarding.step')} {step}
				</Box>
				<Heading
					mt="6px"
					fontWeight="600"
					fontSize="35px"
					lineHeight="120%"
				>
					{header}
				</Heading>
				<Text
					mt="35px"
					lineHeight="160%"
					fontSize="18px"
				>
					{content}
				</Text>
				<Flex
					flexDir="column"
					mt="20px"
					gridGap="10px"
				>
					<Box
						w="18px"
						h="1px"
						bg="white"
					/>
					{links && (
						<Box
							fontWeight="600"
							color="#626262"
						>
							{t('onboarding.links.usefulLinks')}
						</Box>
					)}
					{links?.map(link => {
						return (
							<Link
								color="#FF3F3F"
								href={link.href}
								key={link.href}
								target="blank"
							>
								{link.text}
							</Link>
						);
					})}
				</Flex>
			</Box>
			<Flex
				gridRow={{ base: 'auto', lg: step % 2 == 0 ? '1' : 'auto' }}
				justifyContent="center"
				position="relative"
			>
				<Image
					w="340px"
					src={image}
					zIndex="1"
				/>
				<Image
					w="340px"
					pos="absolute"
					left="0"
					right="0"
					top="0px"
					margin="auto"
					filter="blur(40px)"
					opacity="0.5"
					src={image}
				/>
			</Flex>
		</Grid>
	);
};
